import React, { useEffect, useState } from "react";
import useAxios from "hooks/useAxios";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  FormGroup,
  Label,
} from "reactstrap";
import {
  dateFormate,
  currencyFormat,
  cellRendererCheck,
  dateFormat,
  datetimeformate,
} from "utils/columns";
import plus from "assets/icon/plus-icon.svg";
import deleteicon from "assets/icon/delete-icon.svg";
import { Formik } from "formik";
import Dropzone from "react-dropzone";
import file from "assets/icon/file-icon.svg";
import search from 'assets/icon/search.svg';
import Submit from "assets/icon/Submit.svg";
import { toast } from "react-toastify";
import AddUpdate from "./AddUpdate/Index";
import Drawer from 'components/Drawer';

let notallowtype = ['ppt']

const ViewCaseDetails = (props) => {
  const { toogleview, settoogleView, selectedRow, caseAttachment, setAttachment, loading, setLoading, handleSearch, filters } = props;
  const API = useAxios();
  const [isOpen, setisOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [base64, setBase64] = useState([]);
  const [error, setError] = useState(false);
  const [errorsizevalue, setErrorsizevalue] = useState(false);
  const [errorsize, setErrorsize] = useState(false);

  const [selectedValue, setSelectedValue] = useState([])
  const [fileErrors, setFileErrors] = useState({});
  // console.log(selectedRow, "row", caseAttachment)
  // console.log(selectedRow.customerUpdates)
  const MaxSize = 15 * 1024 * 1024;
  const [openPharmacy, setOpenPharmacy] = useState(false);
  const manvalPharmacy1 = () => {
    // debugger;
    setOpenPharmacy(!openPharmacy);
  };
  const toggle = () => {
    debugger;
    settoogleView(!toogleview);
    setErrorsize(false)
    setError(false)
    setFileErrors({})
    handleSearch(filters)
  };
  const handelAddAtachments = () => {
    setisOpen(!isOpen);
    setErrorsize(false)
    setError(false)
    setSelectedFile([])
  };
  useEffect(() => {
    if (toogleview == true)
      handelCaseData()
  }, [toogleview])
  const handelCaseData = async () => {
    const paylod = {}
    paylod.caseId = selectedRow.caseId
    paylod.opaCode = selectedRow.opaCode
    setLoading(true)
    try {
      const { data } = await API.post(`/api/Search/casedata`, paylod)
      setAttachment(data)
      setSelectedValue(data)
      setLoading(false)
      // console.log(data,"data")
    }
    catch (error) {
      console.log(error)
      setLoading(false)

    }

  }
  const handelDownload = async (item) => {
    console.log(item, "item")
    debugger;

    // handelRemoveError(item)
    if (notallowtype.some(type => item.fileType.includes(type))) {
      toast.error("You can't downlaod the PPT file")
      return true;
    }

    // if(item.fileType=="ppt" || item.fileType=="pptl" || item.fileType=="pptx"){
    //   toast.error("You can't downlaod the PPT file")
    //   return;
    // }

    const paylod = {}
    paylod.attachmentId = item.attachmentId
    paylod.fileType = item.fileType
    paylod.fileName = item.fileName
    // debugger;
    setFileErrors({})
    let MaxSize = 15 * 1024 * 1024
    let endpoint = ""
    if (item.fileSize > MaxSize) {
      console.log("value")
      // toast.error("The file you are downlaoding is greater than 15Mb")
      setFileErrors(prev => ({
        ...prev,
        [item.attachmentId]: true
      }));
      // setErrorsizevalue(true)
      return
    }
    setFileErrors({})
    if (item.fileSize < 2 * 1024 * 1024) {
      endpoint = "api/search/downloadsmallattachment"
    }
    else {
      endpoint = "api/search/downloadbigattachment"
    }
    try {
      const { data } = await API.post(`${endpoint}`, paylod, {
        responseType: "blob",
        hasDefaultURL: true,
      });
      const fileExtension = item.fileType;
      const fileName = `${item.fileName}`;
      const blob = new Blob([data], { type: `application/${fileExtension}` });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const onHandleFileChange = (acceptedFiles) => {
    // for one file
    // debugger;
    setErrorsize(false)
    setError(false)

    if (!acceptedFiles || acceptedFiles.length === 0) return;

    const file = acceptedFiles[0];

    const isUnsupported = /\.(ppt|pptx)$/i.test(file.name);
    if (isUnsupported) {
      // alert("PowerPoint files (.ppt, .pptx) are not supported.");
      setSelectedFile([])
      setError(true);
      return;
    }

    if (file.size > MaxSize) {
      // alert("File size exceeds the maximum allowed limit.");
      // setError(true);
      setSelectedFile([])
      setErrorsize(true)
      return;
    }

    file.id = Math.floor(Math.random() * 1000000);
    setSelectedFile([file]);

    const reader = new FileReader();
    setError(false)
    setErrorsize(false)

    reader.onloadend = () => {
      const base64Only = reader.result.split(",")[1];
      setBase64([{ id: file.id, base64: base64Only }]);
      setError(false);
      setErrorsize(false)

    };
    reader.onerror = (error) => {
      console.error("File reading error:", error);
      setError(true);
    };
    reader.readAsDataURL(file);
  };
  console.log(selectedFile, "file", base64)
  const handelRemovePDF = (item) => {
    const removepdf = selectedFile.filter((value) => value.id != item.id);
    console.log(removepdf, "removepdf");
    setSelectedFile(removepdf);
  };
  const handelRemoveError = (item) => {
    // debugger;
    //    setFileErrors((prevErrors) => {
    //   const updatedErrors = { ...prevErrors };
    //   delete updatedErrors[item.fileName]; 
    //   return updatedErrors;
    // });
    setFileErrors({})
  };
  console.log(fileErrors, "file")

  const caseattachments = async () => {
    const paylod = {}
    // paylod.caseId = "500cZ000006f8ZGQAY"
    paylod.caseId = selectedRow.caseId

    const { data } = await API.post(`/api/search/caseattachments`, paylod,)
    // console.log(data,)
    if (data) {
      setAttachment(data)
    }
  };
  const handleSubmit = async () => {
    // debugger;
    let paylod = {};
    let payload1 = {}
    payload1.caseId = selectedRow?.caseId
    let fileSize = ""

    paylod.caseId = selectedRow?.caseId
    if (selectedFile && selectedFile.length > 0 && base64.length > 0) {
      paylod.fileAttachments = selectedFile.map((file) => {
        const filename = file.name
        const filesplit = filename.split(".")[0]
        // const filtetype=file.name.split(".")[1]
        // console.log(filtetype,"type")
        const fileName = selectedFile[0]?.name;
        fileSize = selectedFile[0]?.size
        const nameBeforeExtension = fileName?.substring(0, fileName.lastIndexOf("."));
        console.log(nameBeforeExtension, "name")

        const extension = fileName?.substring(fileName.lastIndexOf(".") + 1);

        const matchingBase64 = base64.find((b64) => b64.id === file.id);
        payload1.fileName = fileName || ""
        payload1.base64Data = matchingBase64 ? matchingBase64.base64 : ""
        payload1.title = ""
        payload1.available_for_Portal = true
        return {
          fileType: extension || "",
          fileName: nameBeforeExtension || "",
          base64Data: matchingBase64 ? matchingBase64.base64 : "",
          // fileSize:fileName.fileSize
        };
      });

    } else {
      paylod.fileAttachments = [];
    }



    // setLoading(true);
    if (fileSize < 2 * 1024 * 1024) {
      try {

        const data = await API.post(`api/search/addsmallattachments`, paylod, {
          hasDefaultURL: true,
        });
        if (data?.data.status == "Success") {
          toast.success(data?.data.message);
          handelCaseData()
          // caseattachments()
        } else if (data?.data.status == "Error") {
          toast.success(data?.data.message);
        }
        handelAddAtachments();
        setSelectedFile([])
        // setLoading(false);
        // console.log(data, "data");
      } catch (error) {
        // setLoading(false);
        console.log(error)
      }
    }
    else {
      try {

        const data = await API.post(`api/search/addbigattachments`, payload1, {
          hasDefaultURL: true,
        });
        if (data?.data.status == "Success") {
          toast.success("Attachment Updated Successfully");
          handelCaseData()
          // caseattachments()
        } else if (data?.data.status == "Error") {
          toast.success("Attachment Failed");
        }
        handelAddAtachments();
        setSelectedFile([])
        // setLoading(false);
        // console.log(data, "data");
      } catch (error) {
        // setLoading(false);
        console.log(error)
      }
    }
    // submit();
    // setLoading(true);
  };

  //   console.log(selectedRow)
  return (
    <div hidden={!toogleview}>
      <div className="d-flex align-items-baseline">
        <Breadcrumb>
          <BreadcrumbItem active>
            <a onClick={toggle}>Home</a>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <a>View Case</a>
          </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <Card>
        <CardBody>
          <div className="model_view">
            <div class="model_info d-flex justify-content-between align-items-center mb-3"
              style={{ position: "sticky", top: "0", background: "#ffffff" }}>
              <div class="mr-auto">
                <div className="f-20 text-primary font-weight-600">
                  {caseAttachment?.caseNo} - {caseAttachment?.subject}
                </div>


              </div>
              <div 
              hidden={caseAttachment?.status=="Closed"}
              >
                <Drawer
                  direction='end'
                  isOpen={openPharmacy}
                  toggle={manvalPharmacy1}
                  // size='lg'
                  title='Customer Updates'
                >
                  <AddUpdate
                    manvalPharacy={manvalPharmacy1}
                    Loading={loading}
                    setLoading={setLoading}
                    caseAttachment={caseAttachment}
                    setAttachment={setAttachment}
                    submit={handleSubmit}
                    selectedRow={selectedRow}
                  //refetch={refetch}
                  // onSearch={handleSearch}
                  // Loading={loading}
                  // onSave={handlecoveredEntity}
                  />
                </Drawer>
                <Button
                  onClick={manvalPharmacy1}
                  color="primary"
                  className="reset addbtn"
                // disabled={addDisable}
                //hidden={!hasPermission("ADD")}
                >
                  {/* <span className="right_5">
                    <img src={plus} alt="" />
                  </span> */}
                  Add/{" "}View Updates
                </Button>
              </div>
            </div>

            <Row>
              <Col md={8}>
                <div>
                  <Row className="mb-0">
                    <Col md={4}>
                      <h4 className="view-details">Product Line : <p>
                        {caseAttachment?.productLine}
                      </p></h4>
                    </Col>
                    <Col md={4}>
                      <h4 className="view-details">Case Reason : <p>{caseAttachment?.caseReason}</p></h4>
                    </Col>
                    <Col md={4}>
                      <h4 className="view-details">Case Sub Reason : <p>{caseAttachment?.caseSubReason}</p></h4>
                    </Col>
                  </Row>
                </div>
                <div>
                  <div
                    className="view_de_left"
                    style={{ paddingRight: "1rem" }}
                  >
                    <h3 className="f-16 font-weight-600 pt-3">Description</h3>
                    <p
                      className="f-16 font-weight-500"
                      dangerouslySetInnerHTML={{
                        __html: caseAttachment?.description,
                      }}
                    ></p>
                  </div>
                  <div
                    className="view_de_left"
                    style={{ paddingRight: "1rem" }}
                  >
                    <h3 className="f-16 font-weight-600 pt-3">PharmaForce Notes</h3>
                    <p
                      className="f-16 font-weight-500"
                      dangerouslySetInnerHTML={{ __html: caseAttachment?.notes }}
                    ></p>
                  </div>
                </div>
              </Col>

              <Col md={4}>
                <div
                  className=""
                // style={{ position: "sticky", top: "47px" }}
                >
                  <div className="view_de_left right">
                    <h3 className="f-16 font-weight-600">Case Details</h3>
                    <ul
                      className=""
                      style={{ paddingRight: "8px", paddingLeft: "0" }}
                    >
                      <li className="d-flex justify-content-between f-14 font-weight-500">
                        Status :{" "}
                        <span className="font-weight-600">
                          {caseAttachment?.status}
                        </span>
                      </li>
                      {/* <li className='d-flex justify-content-between f-14 font-weight-500'>Priority : <span className='font-weight-600'>{caseAttachment?.priority}</span></li> */}
                      <li className="d-flex justify-content-between f-14 font-weight-500">
                        Requested by :{" "}
                        <span className="font-weight-600">
                          {caseAttachment?.requestedBy}
                        </span>
                      </li>
                      {/* <li className='d-flex justify-content-between f-14 font-weight-500'>Service Line : <span className='font-weight-600'>{caseAttachment?.serviceLine}</span></li> */}
                      <li className="d-flex justify-content-between f-14 font-weight-500">
                        Opened Date/Time :{" "}
                        <span className="font-weight-600">
                          {datetimeformate(caseAttachment?.openDate)}
                        </span>
                      </li>
                      <li className="d-flex justify-content-between f-14 font-weight-500">
                        Closed Date/Time :{" "}
                        <span className="font-weight-600">
                          {datetimeformate(caseAttachment?.closeDate)}
                        </span>
                      </li>
                      <li className="d-flex justify-content-between f-14 font-weight-500">
                        Last Update Date/Time :{" "}
                        <span className="font-weight-600">
                          {datetimeformate(caseAttachment?.lastUpdated)}
                        </span>
                      </li>
                      <li className="d-flex justify-content-between f-14 font-weight-500">
                        Estimated Date of Completion :{" "}
                        <span className="font-weight-600">
                          {dateFormate(caseAttachment?.estimatedDate)}
                        </span>
                      </li>
                      {/* <li className='d-flex justify-content-between f-14 font-weight-500'>Wait Time (Days) : <span className='font-weight-600'>{selectedRow?.waitTime}</span></li> */}
                    </ul>
                  </div>

                  <div className=" right mt-2">
                    <div className="d-flex justify-content-between view_de_left atc_info">
                      <h3 className="f-16 font-weight-600">Attachments</h3>

                      <a className="f-14 font-weight-500 cursor-pointer"
                      hidden={caseAttachment?.status=="Closed"}
                        style={{ color: "#702C62", cursor: "pointer", paddingRight: "8px", }} color="primary"
                        onClick={handelAddAtachments}
                      >
                        <span className="right_5" >
                          <img src={plus} alt="" />
                        </span>
                        Add
                      </a>
                    </div>
                    <div
                      className=""
                      style={{ paddingRight: "8px", paddingLeft: "0", paddingTop: '10px' }}
                    >
                      {caseAttachment?.attachments?.map((item) => {
                        const parts = item.fileName.split(".");
                        const combined =
                          parts[0] && parts[1] ? `${parts[0]}.${parts[1]}` : "";
                        const isFileTooLarge = fileErrors[item.attachmentId]
                        // console.log(filename,"name")
                        // console.log(item, "item")
                        return (
                          <div>
                            <div className="d-flex justify-content-between">
                              <ul className="lineheight at-info">
                                <li>
                                  <a
                                    className="f-16 font-weight-600"
                                    style={{ color: "#212121" }}
                                  >
                                    {item.fileName}
                                  </a>
                                  <br />

                                </li>
                                {/* <li>
                                <small
                                  className="f-12 font-weight-500"
                                  style={{ color: "#757575" }}
                                >
                                  {item.createdBy}
                                </small>
                              </li> */}
                              </ul>

                              <ul className="lineheight">
                                <li style={{ textAlign: "right" }}
                                >
                                  <a
                                    className="f-12 font-weight-600 cursor-pointer"
                                    style={{ color: "#702C62" }}
                                    onClick={() => handelDownload(item)}
                                  >
                                    Download
                                  </a>
                                </li>
                                <li>
                                  <small
                                    className="f-12 font-weight-500"
                                    style={{ color: "#9E9E9E" }}
                                  >
                                    {datetimeformate(item.createdDate)}
                                  </small>
                                </li>
                              </ul>
                            </div>
                            {isFileTooLarge && (
                              <div className="text-danger f-12"
                                style={{ cursor: "pointer", paddingBottom: "4px" }}
                                onClick={() => handelRemoveError(item.fileName)}
                              >
                                {/* More than 15MB file download is not supported */}
                                Download files cannot be greater than 15 MB.  Please contact the client support team by calling <a href="tel:888-519-8057">888-519-8057</a> or email <a href="mailto:support@thepharmaforce.com">support@thepharmaforce.com</a>
                                {/* File download should not be greater than 15MB */}
                                <img
                                  style={{ position: "relative", top: "-2px", paddingLeft: "8px" }}
                                  src={deleteicon}
                                />
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
      <Modal
        isOpen={isOpen}
        toggle={handelAddAtachments}
        size="sm"
        className="sm d-flex align-items-center" style={{ height: "calc(100% - 76px)" }}
      >
        <ModalHeader className="top_hed" toggle={handelAddAtachments}
          style={{ color: "#702C62", borderbottom: "1px solid #D3D3D3;" }}
        >
          Add Attachments
        </ModalHeader>

        <ModalBody>
          <Formik
            onSubmit={handleSubmit}
            initialValues={{}}
            enableReinitialize={true}
            children={(props) => {
              return (
                <Row>
                  <Col md={12} lg={12} sm={12} xs={12}>
                    <FormGroup>
                      {/* <Label>Attachment</Label> */}
                      <Dropzone
                        onDrop={onHandleFileChange}
                        multiple={false}
                      >
                        {({
                          getRootProps,
                          getInputProps,
                          isDragActive,
                        }) => (
                          <section
                            className={`drop-zone ${isDragActive ? "active" : ""
                              }`}
                          >
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div className="browse">
                                <Button className="highlight font-weight-600">
                                  <span className="right_5">
                                    <img src={file} alt="upload icon" />
                                  </span>
                                  Choose File
                                </Button>
                                <span>or Drag and Drop Attachment </span>
                              </div>
                            </div>
                          </section>
                        )}
                      </Dropzone>

                      {/* Show selected file name */}
                      {selectedFile.length > 0 && (
                        <div className="" style={{ paddingTop: "4px", }}>
                          <strong>Selected File : </strong>{" "}


                          {selectedFile.map((item) => {

                            return (
                              <>
                                <div className="d-flex" style={{ overflowWrap: "anywhere" }}>
                                  <p color="primary" className="" style={{ marginBottom: "0px", paddingLeft: "0px" }}> {item.name}</p>
                                  <span className="" style={{ paddingLeft: "8px", cursor: "pointer", }} onClick={() => handelRemovePDF(item)}>
                                    <img style={{ position: "relative", top: "-2px", }} src={deleteicon} />

                                    {""}{" "}
                                  </span>
                                </div>

                              </>
                            );
                          })}

                        </div>
                      )}
                      {/* single file data */}
                      {/* {selectedFile.length > 0 && (
                            <div>
                              <strong style={{ float: "left" }}>
                                Selected File:{" "}
                              </strong>

                              <div style={{ float: "left" }}>
                                <div className="d-flex">
                                  <p
                                    className=""
                                    style={{
                                      marginBottom: "0px",
                                      paddingLeft: "12px",
                                    }}
                                  >
                                    {selectedFile[0].name}
                                  </p>

                                  <div
                                    className=""
                                    style={{
                                      paddingLeft: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handelRemovePDF(selectedFile[0])
                                    }
                                  >
                                    <img src={deleteicon} alt="Delete" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )} */}

                      {/* {error == true && ( */}
                      {error == true &&
                        <div className="text-danger f-12">
                          PowerPoint files (.ppt, .pptx) are not supported.
                        </div>
                      }
                      {errorsize == true && (
                        // return <div key={item.name}>{item.name}</div>
                        <div className="text-danger f-12 pt-1">
                          {/* File attached should not be greater than 15MB */}
                          Attached files cannot be greater than 15 MB.  Please contact the client support team by calling <a href="tel:888-519-8057">888-519-8057</a> or email <a href="mailto:support@thepharmaforce.com">support@thepharmaforce.com</a>
                        </div>
                      )}
                      {/* )} */}
                    </FormGroup>
                  </Col>
                  <Col sm={0} className="d-flex" style={{ justifyContent: "flex-end" }}>
                    <Label>{""}</Label>
                    <Button
                      color="primary"
                      className="search"
                      onClick={handleSubmit}
                      disabled={selectedFile.length == 0}
                    >
                      <span className='right_5'> <img src={Submit} alt="" /></span>
                      Submit
                    </Button>
                  </Col>
                </Row>
              )
            }}
          ></Formik>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ViewCaseDetails;
